// extracted by mini-css-extract-plugin
export var accentColor = "#df0228";
export var categoryBorderColor = "#f08c2b";
export var disableRipple = "false";
export var fontFamily = "\"Roboto\",\"Helvetica\",\"Arial\",sans-serif";
export var mainColor = "#4b4b4b";
export var mainContrast = "#fff";
export var panelBorderColor = "#c4c8cd";
export var secondaryColor = "#e5f0fa";
export var secondaryContrast = "rgba(0,0,0,.87)";